<template lang="pug">
  #app
    .wrapper
      #sidebar()
        VNavigation()
      #content
        .topbar.w-100.d-flex.align-items-center.pl-4
          Topbar()
        router-view().p-4
</template>

<script>
import {VNavigation, Topbar} from './components/'

export default {
  name: 'App',
  components: {
    VNavigation,
    Topbar
  },
  data() {
    return {
      // sidebarVisible: false
    }
  },
  methods: {
    toggleClass(){
      
    }
  }
}
</script>

<style lang="less">
@import url('./less/global.less');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html, body, #app {
  height: 100%;
}


.topbar {
  height: 70px;
}

.wrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
}

#sidebar {
    min-width: 250px;
    max-width: 250px;
    min-height: 100vh;
    background-color: #F4F8F7;
    @media screen and (max-width: 1200px){
      display: none;
      max-width: 100%;
    }
}

#content {
  flex: 1
}
</style>
